import { useEffect, useRef } from 'react';
import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';
import InteractiveContent from '../InteractiveContent';

const SENDER_ALIGN = { client: 'flex-start', flow: 'flex-end', agent: 'flex-end', admin: 'flex-end' };
const BUBBLE_BG = { client: '#2a2a3e', flow: '#1e3a5f', agent: theme.colors.primary, admin: '#7c3aed' };
const BUBBLE_COLOR = { client: theme.colors.text, flow: '#bfdbfe', agent: '#0f0f0f', admin: '#fff' };
const SENDER_LABEL = { client: '', flow: 'Bot', agent: 'Agente', admin: 'Admin' };

function formatTime(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
}

export default function MessageThread({ messages }) {
  const bottomRef = useRef(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '1rem', display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {messages.map((msg, i) => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: SENDER_ALIGN[msg.send] }}>
          {msg.send !== 'client' && (
            <span style={{ fontSize: '0.7rem', color: theme.colors.textMuted, marginBottom: '2px', paddingRight: '4px' }}>
              {SENDER_LABEL[msg.send]}
            </span>
          )}
          <div style={{
            maxWidth: isMobile ? '85%' : '65%', padding: '8px 12px', borderRadius: '12px',
            background: BUBBLE_BG[msg.send],
            color: BUBBLE_COLOR[msg.send],
            fontSize: '0.88rem', lineHeight: '1.5', wordBreak: 'break-word',
            borderBottomLeftRadius: msg.send === 'client' ? '4px' : '12px',
            borderBottomRightRadius: msg.send !== 'client' ? '4px' : '12px',
          }}>
            {msg.type === 'text' && <span style={{ whiteSpace: 'pre-wrap' }}>{msg.content}</span>}
            {msg.type === 'interactive' && (
              <InteractiveContent interactive={msg.interactive} body={msg.content} dark={msg.send === 'agent'} />
            )}
            {msg.type === 'image' && (
              <a href={msg.media_url} target="_blank" rel="noreferrer">
                <img src={msg.media_url} alt="img" style={{ maxWidth: '200px', borderRadius: '8px', display: 'block' }} />
              </a>
            )}
            {msg.type === 'video' && <video controls src={msg.media_url} style={{ maxWidth: '220px', borderRadius: '8px' }} />}
            {msg.type === 'audio' && <audio controls src={msg.media_url} style={{ maxWidth: '200px' }} />}
            {(msg.type === 'file' || msg.type === 'document') && (
              <a href={msg.media_url} target="_blank" rel="noreferrer" style={{ color: 'inherit' }}>📎 {msg.content || 'Archivo adjunto'}</a>
            )}
            <div style={{ fontSize: '0.68rem', opacity: 0.7, textAlign: 'right', marginTop: '4px' }}>
              {formatTime(msg.created_at)}
              {msg.send !== 'client' && msg.status && ` · ${msg.status}`}
            </div>
          </div>
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
}
